// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__0wg6b"};